/* eslint-disable */

(function() {
  var $ = require('jquery');
  require('jquery-placeholder/jquery.placeholder.js');

  $('input, textarea').placeholder();
})();
